import { UserDisplay } from "../../../../../../design-system/components/UserDisplay/UserDisplay.jsx";
import DeleteUserFromWorkshopButton from "../DeleteUserFromWorkshopButton/DeleteUserFromWorkshopButton.jsx";
import ResetPasswordDialog from "../ResetPasswordDialog/ResetPasswordDialog.jsx";
import styles from "./StudentList.css.ts";

/**
 * Renders a list of students with additional functionalities for managing users in a workshop.
 *
 * @param {Object} props - The properties object.
 * @param {Array} props.students - The array of student objects to be displayed.
 * @param {Object} props.workshop - The workshop object representing the current workshop context.
 * @param {Function} props.drop - Ref callback to set the droppable area for drag-and-drop functionality.
 * @param {boolean} props.isInGroup - Indicates if the student list is part of a group.
 *
 * @return {JSX.Element} Returns a list of students with draggable functionality and additional action menus.
 */
function StudentList({ students, workshop, drop, isInGroup }) {
  return (
    <ul ref={drop} className={styles.droppable}>
      {students.map((student) => (
        <li key={student.id}>
          <UserDisplay
            user={student}
            groupId
            menuItems={
              <>
                <ResetPasswordDialog user={student} />

                <DeleteUserFromWorkshopButton
                  workshop={workshop}
                  user={student}
                />
              </>
            }
            draggable
            brighterBackground={isInGroup}
          />
        </li>
      ))}
    </ul>
  );
}

export default StudentList;
